// Recovered compiled webpack factory 69142. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    return "isRelative" in e;
  }
  function a(e, t) {
    let r = 0 >= e.indexOf("://") && 0 !== e.indexOf("//"),
      n = t ?? (r ? "thismessage:/" : void 0);
    try {
      if ("canParse" in URL && !URL.canParse(e, n)) return;
      let t = new URL(e, n);
      if (r) return { isRelative: r, pathname: t.pathname, search: t.search, hash: t.hash };
      return t;
    } catch {}
  }
  function o(e) {
    if (n(e)) return e.pathname;
    let t = new URL(e);
    return (
      (t.search = ""),
      (t.hash = ""),
      ["80", "443"].includes(t.port) && (t.port = ""),
      t.password && (t.password = "%filtered%"),
      t.username && (t.username = "%filtered%"),
      t.toString()
    );
  }
  function i(e) {
    if (!e) return {};
    let t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!t) return {};
    let r = t[6] || "",
      n = t[8] || "";
    return { host: t[4], path: t[5], protocol: t[2], search: r, hash: n, relative: t[5] + r + n };
  }
  function s(e) {
    return e.split(/[?#]/, 1)[0];
  }
  function l(e, t = !0) {
    if (e.startsWith("data:")) {
      let r = e.match(/^data:([^;,]+)/),
        n = r ? r[1] : "text/plain",
        a = e.includes(";base64,"),
        o = e.indexOf(","),
        i = "";
      if (t && -1 !== o) {
        let t = e.slice(o + 1);
        i = t.length > 10 ? `${t.slice(0, 10)}... [truncated]` : t;
      }
      return `data:${n}${a ? ",base64" : ""}${i ? `,${i}` : ""}`;
    }
    return e;
  }
  r.d(t, { CH: () => o, Dl: () => i, f: () => s, kg: () => a, nt: () => n, zm: () => l });
}
